export const Work = [
    {
        id:1,
        name:"NFTroot",
        description:"Made a e-commerce website for buying nft's. Here you can purchase nft's using the custom made token, buy token's using Eth. You can see the transaction live on the Etherscan website. ",
        tags:["Solidity","NextJS","Moralis"],
        
        demo:"https://6279671fe3c39b00a8ca9bbf--thriving-biscochitos-e9958a.netlify.app/",
        github:"https://github.com/Harsh3363/Web3Amazon"
    },
    {
        id:2,
        name:"CabMe",
        description:"A web3 version of Uber, where you can make payments using the Eth.  Select the pickUp and DropOff location and get estimated fare",
        tags:["Solidity","NextJS","Sanity.io","MapBox API"],
        
        demo:"https://uber-c0fs60k3j-harsh3363.vercel.app/",
        github:"https://github.com/Harsh3363/uber"
    },
    {
        id:3,
        name:"News Letter webapp",
        description:"Using the MailChimp Api build a news-letter website. In this user just need to put their email ID to subscribe.",
        tags:["JavaScript","npm","API"],
        
        demo:"https://peaceful-sea-86348.herokuapp.com/",
        github:"https://github.com/Harsh3363/new-letter-web-app"
    },
    {
        id:2,
        name:"Tinder-web3",
        description:"Web3 Tinder where user needs to log-in using metamask, same functionality as Tinder and if there will be a match then a nft will be minted.",
        tags:["Solidity","NextJS","Sanity.io","Moralis","npm"],
        
        demo:"https://tinder-eceqeidps-harsh3363.vercel.app/",
        github:"https://github.com/Harsh3363/tinder"
    },
    {
        id:4,
        name:"Secrets website",
        description:"This is a simple web application to tell your secrets anonymously 🤐. Built using OAuth, MongoDB",
        tags:["MongoDB","OAuth"],
        
        demo:"",
        github:"https://github.com/Harsh3363/secrets"
        
    },
    {
        id:5,
        name:"Todo App",
        description:"A Todo list webApp which helps you keep a note of your daily work. User can use different routes in this to store that specific work.",
        tags:["ReactJS","MongoDB","Heroku"],
        
        demo:"https://radiant-sands-00754.herokuapp.com/",
        github:"https://github.com/Harsh3363/todo-v1"
    },
    {
        id:6,
        name:"Keeper App",
        description:"A clone of Google Keep build using ReactJS.",
        tags:["react","react-router"],
        
        demo:"",
        github:"https://github.com/Harsh3363/Keeper"
       
    },
    // {
    //     id:7,
    //     name:"Crowd-Funding DApp",
    //     description:"A crowd funding DApp build using Solidity.",
    //     tags:["solidity"],
        
    //     demo:"",
    //     github:"https://github.com/Harsh3363/crowd-funding"
        
    // },
  
    
  
] 
